export enum Permissions {
	ADMIN = '50',
	ADDITION_AND_DEDUCTION_ADDING = '53',
	DISPATCHER = '44',
	DEPARTMENTS_ACCESS = '38',
	EVENT_BUSINESS_PAYMENTS = '41',
	GOOGLE_CONTACTS = '49',
	CREDIT_CARDS = '35',
	CREDIT_CARDS_TRANSACTION_KINDS = '36',
	CREDIT_CARDS_TRANSACTIONS = '37',
	CREDIT_CARDS_MANAGEMENT = '43',
	DRIVER_ACCESS = '11',
	DRIVER_CALENDAR_ACCESS = '12',
	DRIVER_CALENDAR_MANAGEMENT = '25',
	DRIVER_MANAGEMENT = '16',
	BANK_ACCOUNTS = '34',
	CORRESPONDENCE_INCOMING_MANAGEMENT = '13',
	LEAD_ACCESS = '1',
	LEAD_MANAGEMENT = '14',
	NEW_RESERVATION_SYSTEM = '45',
	CHECK_IN_ACCESS = '3',
	CHECK_IN_MANAGEMENT = '17',
	OFFERS_ACCESS = '7',
	OFFERS_MANAGEMENT = '18',
	PILOTS_ACCESS = '30',
	PILOTS_CALENDAR_ACCESS = '32',
	PILOTS_CALENDAR_MANAGEMENT = '33',
	PILOTS_MANAGEMENT = '31',
	VEHICLES_ACCESS = '10',
	VEHICLES_CALENDAR_ACCESS = '2',
	VEHICLES_CALENDAR_MANAGEMENT = '15',
	VEHICLES_EVENTS_ADDITIONS_BESIDES_CONFLICTS = '40',
	VEHICLES_EVENTS_ACCESS = '5',
	VEHICLES_EVENTS_DISABLE_AUTO_DATES_CONFIRMS = '39',
	VEHICLES_EVENTS_MANAGEMENT = '24',
	VEHICLES_MANAGEMENT = '19',
	DEPARTURES_ACCESS = '4',
	DEPARTURES_MANAGEMENT = '20',
	PAYMENTS_RENTALS = '42',
	RESERVATIONS_ACCESS = '9',
	RESERVATIONS_MANAGEMENT = '21',
	RESIDENT_TRIPS_DB_ACCESS = '48',
	RESIDENT_ACCESS = '46',
	RESIDENT_ACCOMMODATION_MANAGEMENT = '47',
	SCHEDULES_ACCESS = '8',
	SCHEDULES_MANAGEMENT = '22',
	SEASON_ACCESS = '6',
	SEASON_MANAGEMENT = '23',
	SELLER = '54',
	TIR_ACCESS = '51',
	USERS_ACCESS = '26',
	USERS_GROUPS_ACCESS = '29',
	USERS_GROUPS_MANAGEMENT = '28',
	USERS_MANAGEMENT = '27',
	WORKSHOP_ACCESS = '52',
	VINDICATION_ACCESS = '55',
	TMS_ACCESS = '56',
}
